import React from 'react';
import { MessageCircle } from 'lucide-react';
import { whatsappUrl } from '../utils/whatsapp';
import { trackWhatsAppClick } from '../utils/analytics';

//
// Reusable WhatsApp button. Fires the spec's `whatsapp_click` event with
// source_page + CTA_label so we can measure routing without leaking any
// health context.
//
//   <WhatsAppCta sourcePage="weight_loss" label="Talk to MyDr.Ai" />
//
export default function WhatsAppCta({
  sourcePage = 'unknown',
  label = 'Talk to MyDr.Ai on WhatsApp',
  prefill,
  variant = 'solid',     // 'solid' | 'ghost' | 'inline'
  className = '',
}) {
  function onClick() {
    trackWhatsAppClick({ source_page: sourcePage, cta_label: label });
  }

  const base =
    'inline-flex items-center gap-2 font-medium rounded-full px-6 py-3.5 text-sm transition-colors';
  const styles = {
    solid:  'bg-[#25D366] text-white hover:bg-[#1ebe5b]',
    ghost:  'border border-ink-200 text-ink-900 hover:bg-ink-50',
    inline: 'text-brand-700 hover:underline',
  };

  return (
    <a
      href={whatsappUrl(prefill)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={`${base} ${styles[variant] || styles.solid} ${className}`}
    >
      <MessageCircle size={16} />
      {label}
    </a>
  );
}
